import {PaymentElement, useElements, useStripe} from '@stripe/react-stripe-js';
import React from "react";
import './Stripe.css';
import {useTranslation} from "react-i18next";
import {appdata} from "../../../logic_tmp/appdata/AppData";

export const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const {t} = useTranslation()

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        const result = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: "https://pay.duoclassico.eu/ok",
            },
        });

        if (result.error) {
            // Show error to your customer (for example, payment details incomplete)
            console.log(result.error.message);
        } else {
            // Your customer will be redirected to your `return_url`. For some payment
            // methods like iDEAL, your customer will be redirected to an intermediate
            // site first to authorize the payment, then redirected to the `return_url`.
        }
    };
    const options = {
        defaultValues: {
            billingDetails: {
                address: {
                    country: appdata.country
                }
            }
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <PaymentElement options={options} />
            <div className="app-button d-flex justify-content-around">
                <button disabled={!stripe} className="app-btn app-btn-further next-step-btn">
                    <span>{t("Continue")}</span>
                </button>
            </div>
        </form>
    )
};
